import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import { Task } from 'api/tasks';
import { FetchStatus } from 'data/core';
import { saveTasks } from 'data/tasks/slice';
import { saveCompanyTasksSagaAction } from '../actions';
import { saveCompanyTasks } from '../slice';

function* saveCompanyTasksSaga({ payload }: PayloadAction<Task[]>): Generator {
  const tasks = payload || [];

  yield put(saveCompanyTasks(tasks?.map((t) => t.taskId)));
  yield put(saveTasks({ data: tasks, fetchStatus: FetchStatus.Partial }));
}

export const watchSaveCompanyTasksSaga = function* (): Generator {
  yield takeLatest(saveCompanyTasksSagaAction.type, saveCompanyTasksSaga);
};
